// src/components/InTaxBaseComponent/utils/deductions.js

export const moneyFmt = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "CAD",
  });
  
  /**
   * Compute suggested EI/CPP/CPP2 for a single pay given gross.
   * NOTE: This is a per-pay approximation (cap-aware) and does not
   * subtract prior YTD contributions unless you pass them in.
   */
  export function computeStatutoryDeductions({
    grossForThisPay = 0,
    ytdBeforeThisPay = 0, // total insurable/pensionable BEFORE this pay
    otherDeductionDefs = [], // from configIndex.pickOtherDeductions()
  }) {
    const defByKey = indexOtherDefs(otherDeductionDefs);
  
    // EI
    const ei = (() => {
      const d = defByKey["Employment Insurance (EI)"];
      if (!d) return 0;
      const capBase = Number(d.max_insurable_earnings || 0);
      const rate = Number(d.rate || 0);
      const maxEmployee = Number(d.max_employee_contribution || Infinity);
      // portion still insurable this year
      const remainingBase = Math.max(0, capBase - ytdBeforeThisPay);
      const appliedBase = Math.min(remainingBase, grossForThisPay);
      return clamp(appliedBase * rate, 0, maxEmployee);
    })();
  
    // CPP
    const cpp = (() => {
      const d = defByKey["Canada Pension Plan (CPP)"];
      if (!d) return 0;
      const basicEx = Number(d.basic_exemption || 0);
      const capBase = Number(d.max_pensionable_earnings || 0);
      const rate = Number(d.rate || 0);
      const maxEmployee = Number(d.max_employee_contribution || Infinity);
      const pensionableBefore = Math.max(0, ytdBeforeThisPay - basicEx);
      const remainingBase = Math.max(0, capBase - basicEx - pensionableBefore);
      const appliedBase = Math.max(0, Math.min(remainingBase, grossForThisPay));
      return clamp(appliedBase * rate, 0, maxEmployee);
    })();
  
    // CPP2 (upper earnings)
    const cpp2 = (() => {
      const d = defByKey["Canada Pension Plan (CPP2)"];
      if (!d) return 0;
      const minE = Number(d.min_pensionable_earnings || 0);
      const capBase = Number(d.max_pensionable_earnings || 0);
      const rate = Number(d.rate || 0);
      const maxEmployee = Number(d.max_employee_contribution || Infinity);
  
      // We approximate with this pay's gross over the min threshold,
      // not precise without detailed YTD + thresholds per pay period.
      const eligibleThisPay = Math.max(0, Math.min(capBase, ytdBeforeThisPay + grossForThisPay) - Math.max(minE, ytdBeforeThisPay));
      return clamp(eligibleThisPay * rate, 0, maxEmployee);
    })();
  
    return { ei, cpp, cpp2 };
  }
  
  function clamp(n, lo, hi) { return Math.min(Math.max(n, lo), hi); }
  function indexOtherDefs(arr = []) {
    const map = {};
    for (const d of arr) map[d.name] = d;
    return map;
  }
  